import { GridCellKind } from "@glideapps/glide-data-grid";
import { emptyCellCharacter } from "../../types.js";
import "moment-timezone";
import { isNullOrUndefined } from "../../../../utils/object.js";
import "react-intl";
import { getInvalidDataCell } from "./GlideInvalidDataCell.js";
class GlideCell {
  _valueGetter;
  _emptySymbol;
  constructor(valueGetter, emptySymbol) {
    this._valueGetter = valueGetter;
    this._emptySymbol = emptySymbol;
  }
  getCellContent(model, rawModel, isSummary) {
    let result;
    if (rawModel.isValid) {
      try {
        const value = this._valueGetter(model);
        const formattedValue = this.formatValue(value);
        result = this.isCellEmpty(formattedValue, isSummary) ? this.getNullCell(isSummary) : this.getCustomContent(formattedValue, isSummary);
      } catch {
        result = getInvalidDataCell({ stringifiedModel: rawModel.raw });
      }
    } else {
      result = getInvalidDataCell({ stringifiedModel: rawModel.raw });
    }
    return result;
  }
  getDrawArea(cellRect, theme) {
    return {
      x: cellRect.x + theme.cellHorizontalPadding,
      y: cellRect.y + theme.cellVerticalPadding,
      width: cellRect.width - 2 * theme.cellHorizontalPadding,
      height: cellRect.height - 2 * theme.cellVerticalPadding
    };
  }
  getNullCell(isSummary) {
    return {
      kind: GridCellKind.Text,
      data: null,
      displayData: isSummary ? "" : isNullOrUndefined(this._emptySymbol) ? emptyCellCharacter : this._emptySymbol,
      allowOverlay: false
    };
  }
}
export {
  GlideCell
};
//# sourceMappingURL=GlideCell.js.map
